import { anyPass, concat, equals } from "ramda";
import { useDrop } from "react-dnd";
import {
  getAnthologies,
  getCollections,
  isApproved,
  isContentGroupTopLevelView,
  isModule,
  useView,
} from "./organizeUtil";
import { useSelected } from "./OrganizeProvider";
import DragItemTypes from "./DragItemTypes";
import { deduplicate, useMediaPermissions } from "../../util/mediaUtil";

export const useParentDrop = ({ parent, onDrop, accept }) => {
  const view = useView();
  const { readOnly } = useMediaPermissions(parent);
  const {
    removeAllSelected,
    selectedContent,
    selectedContentGroups,
  } = useSelected();

  const drop = async item => {
    const activeSelectedMedia = equals(item.mediaType, "content")
      ? selectedContent
      : equals(item.mediaType, "collection")
      ? getCollections(selectedContentGroups)
      : equals(item.mediaType, "anthology")
      ? getAnthologies(selectedContentGroups)
      : [item];

    const dropItems = equals(item.mediaType, "content")
      ? activeSelectedMedia
      : deduplicate(concat([item], activeSelectedMedia));

    const draggingContentIntoContentGroup = () =>
      equals(item.mediaType, "content") &&
      anyPass([isContentGroupTopLevelView, isApproved])(view);

    const dropAction = draggingContentIntoContentGroup() ? "copy" : "move";

    removeAllSelected();
    onDrop({ dropAction, items: dropItems, dropItemMediaType: item.mediaType });
  };

  return useDrop(
    () => ({
      accept,
      drop,
      canDrop: item => {
        if (!readOnly) {
          if (item.parent) {
            return !equals(item.parent.id, parent.id);
          } else if (item.dragAction) {
            if (item.dragAction === "copy" && item.mediaType === "collection") {
              return isModule(parent);
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
        contentIsDragging: monitor.getItemType() === DragItemTypes.CONTENT,
      }),
    }),
    [parent, readOnly, onDrop],
  );
};
